import { ApolloLink } from 'apollo-link';
import { onError } from 'apollo-link-error';

import { UrlQueryInput, UrlQueryResult } from '../types';

export const GqlError = {
    NotFound: 'NotFound',
    GqlError: 'GqlError',
    Network: 'Network',
    Redirect: 'Redirect',
};

export type GqlErrors =
    | {
          type: typeof GqlError.NotFound;
          payload: { pathname: string };
      }
    | {
          type: typeof GqlError.GqlError;
          payload: { message: string; locations?: any; path?: readonly (string | number)[] };
      }
    | {
          type: typeof GqlError.Network;
          message: string;
      }
    | RedirectError;

export type RedirectError = {
    type: typeof GqlError.Redirect;
    payload: {
        status: number;
        url: string;
    };
};

export function getUrlResolverError(errors: GqlErrors[], debug: any) {
    return new ApolloLink((operation, forward) => {
        if (!forward) {
            return null;
        }
        return forward(operation).map((data) => {
            switch (operation.operationName) {
                case 'resolveUrl': {
                    const vars = operation.variables as UrlQueryInput;
                    const response = data.data as { urlResolver: UrlQueryResult };
                    if (response.urlResolver === null || response.urlResolver.type === null) {
                        errors.push({
                            type: GqlError.NotFound,
                            payload: {
                                pathname: vars.urlKey!,
                            },
                        });
                    } else if (response.urlResolver.type === 'REDIRECT') {
                        errors.push({
                            type: GqlError.Redirect,
                            payload: {
                                status: response.urlResolver.redirect_type!,
                                url: response.urlResolver.redirect_url!,
                            },
                        });
                        /**
                         * This case is for the default magento urlResolver query
                         */
                    } else if (
                        typeof (response.urlResolver as any).redirectCode === 'number' &&
                        (response.urlResolver as any).redirectCode !== 0 &&
                        typeof response.urlResolver.relative_url === 'string'
                    ) {
                        errors.push({
                            type: GqlError.Redirect,
                            payload: {
                                status: (response.urlResolver as any).redirectCode!,
                                url: '/' + response.urlResolver.relative_url!,
                            },
                        });
                    } else {
                        debug(vars.urlKey, response.urlResolver.type);
                    }
                    break;
                }
                case 'productDetail': {
                    debug(operation.variables);
                    break;
                }
                default:
                    return data;
            }
            return data;
        });
    });
}

export function getNetworkErrors(errors: GqlErrors[]) {
    return onError(({ graphQLErrors, networkError }) => {
        if (graphQLErrors) {
            graphQLErrors.forEach(({ message, locations, path }) => {
                // eslint-disable-next-line no-console
                console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
                errors.push({
                    type: GqlError.GqlError,
                    payload: { message, locations, path },
                });
            });
        }

        if (networkError) {
            console.error(`[GraphQL Network error]: Message: ${networkError.toString()}`);
            errors.push({
                type: GqlError.Network,
                message: networkError.toString(),
            });
        }
    });
}
